import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { Link } from 'react-router-dom';

export default function OurServicesPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center bg-cover bg-center" style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/abe25c5fefc1c109e552b19cf0648f5d.jpg)' }}>
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="relative max-w-7xl mx-auto px-6 py-20 text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Private Jet <em>Experiences</em> Await
            </h1>
            <p className="text-xl mb-8 text-white/90 max-w-2xl">
              Discover unparalleled luxury and convenience with Milajet Havacilik's private jet services. Fly in style to Europe, Africa, the Middle East, and Asia aboard our Gulfstream IV-SP. Your journey, your schedule.
            </p>
            <form className="flex gap-2 max-w-md" data-readdy-form id="signup-form">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded text-gray-900 focus:outline-none"
                required
              />
              <button
                type="submit"
                className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Sign up
              </button>
            </form>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold mb-4">
                Explore Our <span className="text-blue-600">Exclusive</span> Private Jet Services and Destinations
              </h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                At Milajet Havacilik, we offer unparalleled private jet services tailored to your needs. Fly in luxury and comfort to a wide range of destinations across Europe, Africa, the Middle East, and Asia. Our dedicated team ensures a seamless and personalized travel experience from start to finish.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/036e19a2701002dfa08cbc2b81c18f6c.jpeg"
                  alt="Gulfstream IV-SP"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h5 className="font-bold text-xl mb-3">Gulfstream IV-SP</h5>
                  <p className="text-gray-600 mb-4">
                    Experience the pinnacle of private aviation with our Gulfstream IV-SP. This aircraft offers unmatched comfort, range, and reliability, ensuring a smooth and enjoyable journey to your destination.
                  </p>
                  <Link
                    to="/contact"
                    className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
                  >
                    Learn More →
                  </Link>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stunning%20European%20cityscape%20with%20historic%20architecture%20elegant%20buildings%20cobblestone%20streets%20luxury%20travel%20destination%20featuring%20iconic%20landmarks%20beautiful%20old%20town%20squares%20charming%20cafes%20romantic%20atmosphere%20clear%20blue%20sky%20golden%20hour%20lighting%20professional%20travel%20photography%20showcasing%20European%20culture%20and%20sophistication&width=600&height=400&seq=europe-destination-services-001&orientation=landscape"
                  alt="Destinations: Europe"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h5 className="font-bold text-xl mb-3">Destinations: Europe</h5>
                  <p className="text-gray-600 mb-4">
                    Discover the beauty and culture of Europe with our private jet services. From the bustling cities to the serene countryside, we can take you wherever you desire in style and comfort.
                  </p>
                  <Link
                    to="/contact"
                    className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
                  >
                    Learn More →
                  </Link>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Breathtaking%20African%20landscape%20with%20vast%20savanna%20golden%20grasslands%20acacia%20trees%20majestic%20wildlife%20safari%20destination%20stunning%20sunset%20warm%20orange%20and%20amber%20tones%20dramatic%20sky%20luxury%20travel%20photography%20showcasing%20natural%20beauty%20diverse%20terrain%20mountains%20in%20distance%20pristine%20wilderness%20adventure%20destination&width=600&height=400&seq=africa-destination-services-002&orientation=landscape"
                  alt="Destinations: Africa"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h5 className="font-bold text-xl mb-3">Destinations: Africa</h5>
                  <p className="text-gray-600 mb-4">
                    Explore the diverse landscapes and vibrant cultures of Africa with our exclusive private jet charters. We provide access to remote destinations and unique experiences tailored to your preferences.
                  </p>
                  <Link
                    to="/contact"
                    className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
                  >
                    Learn More →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
